/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['түн орт', 'чт', 'эртң мн', 'түшт кйн', 'кечк', 'түн'],
    [
      'түн ортосу', 'чак түш', 'эртең менен', 'түштөн кийин',
      'кечинде', 'түн ичинде'
    ],
  ],
  [
    [
      'түн ортосу', 'чак түш', 'эртең менен', 'түштөн кийин',
      'кечкурун', 'түн'
    ],
    ,
  ],
  [
    '00:00', '12:00', ['06:00', '12:00'], ['12:00', '18:00'], ['18:00', '21:00'],
    ['21:00', '06:00']
  ]
];
